import { startOfDay, subDays } from "date-fns";
import type { AssistantChat } from "../../../api/types/assistantTypes";

export interface ChatGroup {
  label: string;
  defaultExpanded: boolean;
  chats: AssistantChat[];
}

export const groupChatsByDate = (chats: AssistantChat[], now: Date): ChatGroup[] => {
  const todayStart = startOfDay(now);
  const previous7DaysStart = subDays(todayStart, 7);

  const groups: ChatGroup[] = [
    { label: "Today", defaultExpanded: true, chats: [] },
    { label: "Previous 7 days", defaultExpanded: false, chats: [] },
    { label: "Older", defaultExpanded: false, chats: [] },
  ];

  for (const chat of chats) {
    const lastMessageAt = new Date(chat.lastMessageAt);
    const groupIndex = lastMessageAt >= todayStart ? 0 : lastMessageAt >= previous7DaysStart ? 1 : 2;
    groups[groupIndex]?.chats.push(chat);
  }

  return groups.filter((group) => group.chats.length > 0);
};

export const clearChatUnreadUpdates = (groups: ChatGroup[], threadId: string): ChatGroup[] =>
  groups.map((group) => ({
    ...group,
    chats: group.chats.map((chat) => (chat.threadId === threadId ? { ...chat, hasUnreadUpdates: false } : chat)),
  }));

// Titles store the typographic apostrophe, while a keyboard types the straight one.
const normalizeTitleForSearch = (text: string) => text.toLocaleLowerCase().replaceAll("’", "'");

export const filterChatGroupsByTitle = (groups: ChatGroup[], searchText: string): ChatGroup[] => {
  const normalizedText = normalizeTitleForSearch(searchText.trim());
  if (!normalizedText) {
    return groups;
  }

  return groups
    .map((group) => ({
      ...group,
      chats: group.chats.filter((chat) => chat.title && normalizeTitleForSearch(chat.title).includes(normalizedText)),
    }))
    .filter((group) => group.chats.length > 0);
};
